import React, { useState, useContext, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Avatar,
  Modal,
  Form,
  Input,
  Upload as UploadAntd,
  DatePicker,
  Select,
} from "antd";
import profilavatar from "../../assets/images/face-1.jpg";
import Main from "../../components/layout/Main";
import { ShowToast, Severty } from "../../helper/toast";
import { AuthContext } from "../../context/AuthContext";
import { ExclamationCircleOutlined, UploadOutlined } from "@ant-design/icons";
import { Upload } from "@aws-sdk/lib-storage";
import { s3AwsClient } from "../../config/aws-config";
import moment from "moment";
import useApi from "../../hooks/useApi";
import { getProfile } from "../../constants/API/API";



function Profile() {
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState({});
  const { logout } = useContext(AuthContext);
  const [visible, setVisible] = useState(false);
  const [profileVisible, setProfileVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [refresh, setRefresh] = useState(false);
  const [commission, setCommission] = useState();
  const [nextPayoutDate, setNextPayoutDate] = useState();
  const [payoutFrequency, setPayoutFrequency] = useState();
  const [form] = Form.useForm();
  const { confirm } = Modal;


  useApi({
    callback: getProfile,
    // payload: filters,
    dependencies: [refresh],
    shouldCallApi: true,
    onSuccess: ({ list, totalDocs }) => {
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  const resetData = () => {
    // request({
    //   url: "/common/factory-reset",
    //   method: "GET",
    //   onSuccess: (data) => {
    //     console.log(data);
    //     // ShowToast(data.message, Severty.SUCCESS)
    //     setProfile(data.data);
    //     setSelected(data.data);
    //   },
    //   onError: (error) => {
    //     console.log(error);
    //     ShowToast(error, Severty.ERROR);
    //   },
    // });
  };

  const showConfirm = () => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want to logout ? </Button>,
        onOk() {
          logout();
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const showFactoryData = () => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: (
          <Button>Are you sure you want to Reset all the data ? </Button>
        ),
        onOk() {
          resetData();
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const updateCommission = (values) => {
    // const payload = { ...values };
    // request({
    //   url: apiPath.setCommission,
    //   method: "POST",
    //   data: { ...payload },
    //   onSuccess: (data) => {
    //     if (data?.statusText === "SUCCESS") {
    //       ShowToast(data?.message, Severty.SUCCESS);
    //     } else {
    //       ShowToast(data?.message, Severty.ERROR);
    //     }
    //   },
    //   onError: (err) => {
    //     ShowToast(err?.response?.data?.message, Severty.ERROR);
    //   },
    // });
  };

  return (
    <>
      <Card
        className="card-profile-head"
        bodyStyle={{ display: "none" }}
        title={
          <Row justify="space-between" align="middle" gutter={[24]}>
            <Col span={24} md={24}>
              <Avatar.Group>
                <Avatar
                  size={74}
                  shape="square"
                  src={profile ? profile.profilePic : profilavatar}
                />
                <div className="avatar-info">
                  <h4 className="font-semibold m-0">
                    {profile ? profile.name : ""}
                  </h4>
                  <p>{profile ? profile.email : ""}</p>
                </div>
              </Avatar.Group>
            </Col>
          </Row>
        }
      ></Card>

      <Card className="profile-nav">
        <div className="profile-nav-inner">
          <Button onClick={(e) => setProfileVisible(true)}>Edit Profile</Button>
          <Button onClick={(e) => setVisible(true)}>Change Password</Button>
          {/* <Button onClick={() => showFactoryData()} >Factory Data Reset</Button> */}
          <Button onClick={() => showConfirm()}>Logout</Button>
        </div>
      </Card>

      <SetCommission
        payoutFrequency={payoutFrequency}
        commission={commission}
        nextPayoutDate={nextPayoutDate}
        updateCommission={updateCommission}
      />

      {profileVisible && (
        <EditProfile
          show={profileVisible}
          hide={() => {
            setProfileVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {visible && (
        <ChangePassword
          show={visible}
          hide={() => {
            setVisible(false);
          }}
          // handleCreate={handleCreate}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </>
  );
}

const EditProfile = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);

  const beforeUpload = (file) => {
    // console.log(file.type, "file type>>>>>>.")
    // if (fileType.includes(file.type)) {

    // } else {
    //   message.error("File format is not correct")
    //   return false
    // }
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isLt5M) {
      // ShowToast.error(`Image must be smaller than 5 MB!`)
      return false;
    }
    return true;
  };

  const uploadFileToS3 = async (file, bucketName) => {
    const key = "realState/admin" + file.name;
    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
    };

    const upload = new Upload({
      client: s3AwsClient,
      params: params,
    });

    try {
      const data = await upload.done();
      setLoading(false);
      console.log(data);
      return data;
    } catch (err) {
      throw err;
    }
  };

  const handleChange = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg") && !file.type.includes("gif");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }

    const isValidSize = beforeUpload(file);

    if (!isValidSize) {
      return ShowToast(
        "Image must be smaller than 5 MB!" + file.size / 1024 / 1024,
        Severty.ERROR
      );
    }

    setLoading(true);
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, process.env.REACT_APP_AWS_S3_BUCKET_NAME);
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
      console.log(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
    setFile([data.profilePic]);
  }, [data]);

  const onEditProfile = (values) => {
    const { email, name } = values;
    if (file.length <= 0)
      return ShowToast("Please select the profile Image ", Severty.ERROR);
    const payload = {};
    // setLoading(true);
    // payload.email = email;
    // payload.name = name;
    // payload.profilePic = file.length > 0 ? file[0].url : null;
    // request({
    //   url: "/admin/auth/update-profile",
    //   method: "POST",
    //   data: payload,
    //   onSuccess: (data) => {
    //     setLoading(false);
    //     if (data.status) {
    //       ShowToast(data.message, Severty.SUCCESS);
    //       hide();
    //       refresh();
    //       // hide()
    //     } else {
    //       ShowToast(data.message, Severty.ERROR);
    //     }
    //   },
    //   onError: (error) => {
    //     ShowToast(error.response.data.message, Severty.ERROR);
    //     // console.log(error.response.data, "Error")
    //     setLoading(false);
    //   },
    // });
  };
  return (
    <Modal
      visible={show}
      title={`${data ? "Edit Profile" : ""}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onEditProfile} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                { required: true, message: "Please input the name!" },
                {
                  pattern: new RegExp(/^[a-zA-Z ]*$/),
                  message: "Only Alphabetic Characters Allowed",
                },
                {
                  max: 50,
                  message: "Name cannot exceed 50 characters",
                },
              ]}
              normalize={(value) => value?.trim()}
            >
              <Input placeholder={"Name"} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                { required: true, message: "Please input the email!" },
                {
                  max: 100,
                  message: "Email cannot exceed 100 characters",
                },
              ]}
              normalize={(value) => value?.trim()}
            >
              <Input placeholder={"Email"} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <UploadAntd
              listType="picture"
              maxCount={1}
              customRequest={handleChange}
              onRemove={(e) => setFile([])}
              fileList={file}
            >
              {/* <Button icon={<UploadOutlined />}>Upload</Button> */}
              {file.length > 0 ? null : (
                <Button icon={<UploadOutlined />}>Upload</Button>
              )}
            </UploadAntd>
            <p className="main-new-upload-graph-name-insturction">
              **Logo should be (300-800)X(300-800) for best view in profile
              image. You can select only ( .png, .jpg) format files upto 5 MB
              file size..!!!
            </p>
          </Col>
        </Row>

        {/* <Form.Item name="description" label="Description">
            <Input type="textarea" />
          </Form.Item> */}

        {/* <Form.Item name="type" label="Type">
            <Radio.Group>
              <Radio value="public">Public</Radio>
              
              <Radio value="private">Private</Radio>
            </Radio.Group>
          </Form.Item> */}
      </Form>
    </Modal>
  );
};

const ChangePassword = ({ show, hide }) => {
  const [form] = Form.useForm();
  const { logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const handleCreate = (values) => {
    console.log(values, "values");
    const { old_password, new_password } = values;
    const payload = {};
    if (!old_password || !new_password)
      return ShowToast("Please enter password ", Severty.ERROR);
    // setLoading(true);
    // payload.new_password = new_password;
    // payload.old_password = old_password;
    // request({
    //   url: "/admin/auth/change-password",
    //   method: "POST",
    //   data: payload,
    //   onSuccess: (data) => {
    //     setLoading(false);
    //     if (data.status) {
    //       ShowToast(data.message, Severty.SUCCESS);
    //       hide();
    //       logout();
    //     } else {
    //       ShowToast(data.message, Severty.ERROR);
    //     }
    //   },
    //   onError: (error) => {
    //     ShowToast(error.response.data.message, Severty.ERROR);
    //     // console.log(error.response.data, "Error")
    //     setLoading(false);
    //   },
    // });
  };

  return (
    <Modal
      open={show}
      title="Change password"
      okText="Ok"
      onCancel={() => {
        hide();
        form.resetFields();
      }}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form
        id="create"
        form={form}
        layout="vertical"
        onFinish={handleCreate}
        className="change-pw"
        disabled={loading}
      >
        <Form.Item
          label="Old Password"
          name="old_password"
          hasFeedback
          rules={[
            { required: true, message: "Please input the old password!" },
          ]}
        >
          <Input.Password maxLength={50} placeholder={"Old Password"} />
        </Form.Item>
        <Form.Item
          label="New Password"
          name="new_password"
          hasFeedback
          rules={[
            { required: true, message: "Please input the new password!" },
            {
              min: 8,
              message: "Password must be at least 8 characters long!",
            },
            {
              pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).+$/,
              message:
                "Password must contain at least one uppercase letter, one number, and one lowercase letter!",
            },
            {
              max: 100,
              message: "Password cannot exceed 100 characters",
            },
          ]}
        >
          <Input.Password maxLength={50} placeholder={"New Password"} />
        </Form.Item>
        <Form.Item
          label="Confirm New Password"
          name="confirm_new_password"
          dependencies={["new_password"]}
          hasFeedback
          rules={[
            { required: true, message: "Please input the confirm password!" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Passwords that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password maxLength={50} placeholder={"Confirm New Password"} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const SetCommission = ({
  commission,
  updateCommission,
  payoutFrequency,
  nextPayoutDate,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      vendor_commission: commission ?? 0,
      payoutFrequency: payoutFrequency ?? 0,
      nextPayoutDate: nextPayoutDate ? moment(nextPayoutDate) : "",
    });
  }, [commission, payoutFrequency, nextPayoutDate]);

  const payoutOptions = [
    {
      label: "15 Days",
      value: 15,
    },
    {
      label: "1 Month",
      value: 30,
    },
    {
      label: "1 Year",
      value: 365,
    },
  ];

  return (
    <Card className="profile-nav">
      <div className="profile-nav-inner">
        <Form
          form={form}
          layout="vertical"
          onFinish={updateCommission}
          className="change-pw main-new-commition-text"
        >
          <Row gutter={[24, 4]}>
            <Col span={24}>
              <Form.Item
                label="Vendor Commission (%)"
                name="vendor_commission"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please enter vendor commission!",
                  },
                  {
                    pattern: /^\d+(\.\d{1,2})?$/,
                    message: "Please enter valid number only!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Payout Frequency"
                name="payoutFrequency"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please select vendor Payout Frequency!",
                  },
                ]}
              >
                <Select placeholder={"Select Payout Frequency"}>
                  {payoutOptions.map((item) => (
                    <Select.Option
                      key={item.label}
                      label={item.label}
                      value={item.value}
                    >
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24} sm={24} md={24}>
              <Form.Item
                className="username "
                name="nextPayoutDate"
                label="Next Payout Date"
                rules={[
                  {
                    required: true,
                    message: "Please select date!",
                  },
                ]}
              >
                <DatePicker
                  className="date-inn"
                  placeholder={"Select Custom Date"}
                  format="DD-MM-YYYY"
                  disabledDate={(current) => {
                    return current && current < moment().startOf("day");
                  }}
                />
              </Form.Item>
            </Col>
            <Col xl={24}>
              <Form.Item>
                <Button htmlType="submit">Submit</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Card>
  );
};

export default Profile;
